import Vue from 'vue';

export const EventBus = new Vue();

export const EVENT_FILTER_CLEAR = 'lmc-event-filter-clear';
export const EVENT_FILTER_APPLY = 'lmc-event-filter-apply';